import "./InstallmentData.css";
import images from "../../../../../utilities/images/images";

const renderImg = (elem) => {
  return (
    <img
      src={elem.status === "paid" ? images.paymentDone : images.paymentPending}
      alt="payment-icon"
    />
  );
};

const InstallmentData = ({ data }) => {
  return (
    <table className="installment-table">
      {data?.map((elem, index) => (
        <tr key={index}>
          <td className="installment-label">
            {renderImg(elem)} {elem.label}
          </td>
          <td>{elem.paidDate}</td>
          <td></td>
          <td>{elem.amount}</td>
          <td>
            {elem.status !== "paid" ? (
              <span className="pay-now">
                <a
                  href="https://motion.ac.in/payment-gateway/current-motion-student/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Pay Now
                </a>
              </span>
            ) : (
              ""
            )}
          </td>
        </tr>
      ))}
    </table>
  );
};

export default InstallmentData;
